import React from "react";

import "./WaiverAndIndemnity.scss";

export default function PDPA() {
  return (
    <div className="WAI__mainWrapper">
      <div className="WAI__contentWrapper">
        <h1>WAIVER AND INDEMNITY</h1>
        <ol>
          <li>
            Definitions
            <ol>
              <li>
                "Bus Company" means KAYE TRANSPORT SERVICE PTE LTD [UEN
                202100969W] located at 4 Highgate Walk, Singapore 598755.
              </li>
              <li>
                "School" or “Schools” shall mean whichever school your
                child(ren) attends in which the Bus Company has been contracted
                as a service provider.
              </li>
            </ol>
          </li>
          <li>
            In consideration of you, the School(s) arranging school bus
            transportation services on my behalf for my chil(ren)/ward(s) for
            the purposes of attending school or any school activities by means
            of a bus transportation service provided by an independent
            contractor known as KAYE TRANSPORT SERVICE PTE LTD. I do hereby
            agree as follows
            <ol>
              <li>
                I acknowledge the School acts in a liaison capacity between the
                bus company and the parents/guardians to facilitate the
                provision of school bus transportation services to the students;
                such facilitation includes the negotiation and entry into
                agreements between the School(s) and the Bus Company for the
                provision of school bus transportation services to my
                child/children in accordance with the conditions and bus rules
                defined and agreed by the School(s) on my behalf. I will pay the
                contractor for the bus transport service upon receipt of invoice
                of each quarter at the prescribed rates and I will be bound by
                the conditions and bus rules defined and agreed by the School(s)
                on my behalf. I acknowledge that the bus company is the final
                decision maker with regards to all transport-related matter. Any
                facilitating or liaison services provided by the School(s) are
                purely gratuitous, and that I have the choice of procuring
                transportation services from other service providers.
              </li>
              <li>
                I acknowledge that my child/children is conveyed to and from
                school or any other location by the school bus transportation
                services provided by the Bus Company at my own risk and not at
                the risk of the School(s), which is acting in a liaison role
                between the Bus Company and parents. I agree that the School(s)
                shall not be liable or be responsible for any accident or
                personal injury sustained or suffered by my child/children or
                for my child's death or for any damage or loss to my child's
                personal belongings, however caused, whilst my child/children
                is/are being conveyed, or is/are waiting to be conveyed, to
                and/or from school. I hereby release the School(s) from any and
                all loss, expenses, costs, damages, liability, claim or
                proceedings whatsoever (including for the avoidance of doubt,
                any damages or compensation payable at common law or under any
                law) on account of or arising from any of the foregoing matters,
                including such action that may be taken by the School(s)
                subsequent to any accident or incident in which personal injury,
                death, loss or damage has occurred.
              </li>
            </ol>
          </li>
          <li>
            For the avoidance of doubt, any waiver or exclusion of liability for
            the School(s) is only to the extent permissible by law.
          </li>
          <li>
            This Waiver shall be governed by and construed in all respects in
            accordance with the laws of Singapore.
          </li>
          <li>
            I further agree to indemnify the School(s) against any and all
            claims, damages, costs, actions or causes of action which my
            child/children, his/her next-of-kin, parent, guardian, personal
            representatives and/or dependents may bring, make or have against
            the School(s) on account of any matters above.
          </li>
          <li>
            Reference herein to the School(s) shall include references to the
            school, its employees, agents, servants and any other persons duly
            authorized by the School from time to time; but shall not include
            the Bus Company, bus owners, bus operators and/or any of their
            employees, agents, servants or any other persons authorized to act
            on their behalf.
          </li>
          <li>
            Nothing in this document shall limit the right of any
            child/children, next-of-kin, parent or guardian, personal
            representative and/or dependents from taking action against any
            party other than the School including but not limited to the Bus
            Company and/or their employees, agents or any other persons
            authorized to act on their behalf.
          </li>
        </ol>
      </div>
    </div>
  );
}
